module.exports = __webpack_public_path__ + "img/Piotr_Koniusz@2x.e5debf6f.png";